import { useMutation, useQueryClient } from '@tanstack/react-query';
import { countriesApi } from '../api/countries.api';
import type { UpdateCountryRequest } from '../types/countries.types';
import { COUNTRY_HIERARCHY_INPUT_KEY, COUNTRY_HIERARCHY_MULTI_SELECT_KEY, countryKeys } from './queryKeys';
import { regionKeys } from '@/features/regions/hooks/queryKeys';

export const useUpdateCountry = () => {
  const queryClient = useQueryClient();

  const updateCountry = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCountryRequest }) =>
      countriesApi.updateCountry(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: countryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: countryKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: countryKeys.hierarchy() });
      queryClient.invalidateQueries({ queryKey: [COUNTRY_HIERARCHY_INPUT_KEY] });
      queryClient.invalidateQueries({ queryKey: [COUNTRY_HIERARCHY_MULTI_SELECT_KEY] });
      queryClient.invalidateQueries({ queryKey: regionKeys.lists(), refetchType: 'all' });
    },
  });

  return {
    updateCountry: updateCountry.mutate,
    isUpdating: updateCountry.isPending,
    isSuccess: updateCountry.isSuccess,
  };
};
